import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useCreateBranchTallyUploadMutation } from "store/services/branchTallyUploadApi";
import BranchTallyUploadForm from "../BranchTallyUploadComponents/BranchTallyUploadForm";

const BranchTallyUploadCreateScreen = () => {
  const navigate = useNavigate();
  const [createBranchTallyUpload, { isLoading: creatingBranchTallyUpload }] = useCreateBranchTallyUploadMutation();
  useAppMeta("New Branch Tally Upload");
  const breadcrumbs = [
    { title: "Branch Tally Upload List", path: "/app/crm/reports/branch-tally-upload/list" },
    { title: "New Branch Tally Upload" },
  ];
  const handleAddBranchTallyUpload = async (data) => {
    try {
      const { _id } = await createBranchTallyUpload(data).unwrap();
      toast.success("Branch Tally Upload Created!");
      navigate(`/app/crm/reports/branch-tally-upload/${_id}/detail`);
    } catch (error) {
      toast.error(error?.data?.message ?? error.message ?? "Could not create Branch Tally Upload!");
    }
  };
  return <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingBranchTallyUpload}><BreadcrumbLayout.Paper><BranchTallyUploadForm isBusy={creatingBranchTallyUpload} onSubmit={handleAddBranchTallyUpload} /></BreadcrumbLayout.Paper></BreadcrumbLayout>;
};
export default BranchTallyUploadCreateScreen;
